import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export const authSlice = createSlice({
  name: "authSlice",
  initialState: {
    isLogin: false,
    isRequest: false,
    userData: {
      firstname: "",
      lastname: "",
      email: "",
      role: [],
    },
  },
  reducers: {
    login: (state) => {
      state.isLogin = true;
    },
    logout: (state) => {
      Cookies.remove("access_token");
      Cookies.remove("id_token");

      state.isLogin = false;
      state.userData = {
        firstname: "",
        lastname: "",
        email: "",
        role: [],
      };
    },
    updateUserData: (state, action) => {
      state.userData = {
        ...state.userData,
        ...action.payload,
      };
    },
    updateIsRequest: (state, action) => {
      state.isRequest = action.payload;
    },
  },
});

export const { login, logout, updateUserData, updateIsRequest } = authSlice.actions;

export default authSlice.reducer;
